import { formatAsMoney, formatDefaultDate } from 'plugin/helper'
import React, { Component } from 'react'
import { Card, Alert } from 'react-bootstrap'

class Simulasi extends Component {
  constructor(props) {
    super(props)

    this.state = {
      simulasiBerkala: {},
      simulasiMp: {},
    }
  }

  retrieveData = (data) => {
    if (data) {
      this.setState({
        simulasiBerkala: data.simulasiBerkala,
        simulasiMp: data.simulasiMp,
      })
    }
  }

  render() {
    const { simulasiBerkala, simulasiMp } = this.state
    return (
      <React.Fragment>
        <Card style={{ height: '492px' }} className="mb-3">
          <Card.Body
            style={{
              paddingTop: '12px',
              paddingRight: '16px',
              paddingBottom: '12px',
              paddingLeft: '16px',
            }}
          >
            <section>
              <span style={{ fontWeight: 'bold', fontSize: '20px' }}>
                Kepesertaan Berkala
              </span>

              <Alert key={'warning'} variant={'warning'}>
                <div className="d-flex flex-row align-items-center">
                  <div className="mr-3">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47301 0 0 4.4725 0 10C0 15.5269 4.4725 20 10 20C15.527 20 20 15.5275 20 10C20 4.47309 15.5275 0 10 0ZM11.0269 13.9696C11.0269 14.2855 10.5662 14.6014 10.0002 14.6014C9.40785 14.6014 8.98668 14.2855 8.98668 13.9696V8.95445C8.98668 8.5859 9.40789 8.33574 10.0002 8.33574C10.5662 8.33574 11.0269 8.5859 11.0269 8.95445V13.9696ZM10.0002 7.12484C9.39473 7.12484 8.9209 6.6773 8.9209 6.17707C8.9209 5.67687 9.39477 5.2425 10.0002 5.2425C10.5926 5.2425 11.0665 5.67687 11.0665 6.17707C11.0665 6.6773 10.5925 7.12484 10.0002 7.12484Z"
                        fill="#FFD71A"
                      />
                    </svg>
                  </div>
                  <div>
                    Jika Pembelian Produk Berkala dilakukan Saat ini, Maka
                    Manfaat Pensiun Berkala yang akan di dapatkan Peserta
                    Sebagai Berikut :
                  </div>
                </div>
              </Alert>

              <div className="container-fluid" style={{ fontSize: '14px' }}>
                <div className="row mb-3 mt-3">
                  <div className="col-md-6">
                    <span>Nominal Pembelian Produk Berkala</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {simulasiBerkala.nominalPembelian
                        ? formatAsMoney(simulasiBerkala.nominalPembelian)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Masa Pembayaran Manfaat Pensiun Berkala</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      {simulasiBerkala.masaPembayaran
                        ? simulasiBerkala.masaPembayaran
                        : '-'}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Periode Pembayaran</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      {simulasiBerkala.periodePembayaran
                        ? simulasiBerkala.periodePembayaran
                        : '-'}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Nilai NAV per unit produk berkala terakhir</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {simulasiBerkala.nilaiNav
                        ? formatAsMoney(simulasiBerkala.nilaiNav)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Unit Produk Berkala</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {simulasiBerkala.unitProdukBerkala
                        ? formatAsMoney(simulasiBerkala.unitProdukBerkala)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Unit Pembayaran Per Periode Bayar</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {simulasiBerkala.unitPembayaran
                        ? formatAsMoney(simulasiBerkala.unitPembayaran)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Asumsi Persentase Pengembangan</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      {simulasiBerkala.asumsiPersentase
                        ? simulasiBerkala.asumsiPersentase + ' % p.a'
                        : '-'}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Tanggal Aktiva Terakhir</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      {simulasiBerkala.tanggalAktiva
                        ? formatDefaultDate(
                            new Date(simulasiBerkala.tanggalAktiva)
                          )
                        : '-'}
                    </span>
                  </div>
                </div>

                <Alert
                  key={'primary'}
                  variant={'primary'}
                  className="text-center"
                >
                  <div className="text-center">
                    <div className="d-flex flex-row justify-content-between">
                      <span>
                        Nilai Manfaat Pensiun Per Periode Tahun Pertama
                      </span>
                      <span>
                        {simulasiBerkala.nilaiManfaatPensiun
                          ? formatAsMoney(simulasiBerkala.nilaiManfaatPensiun) +
                            ' per Periode'
                          : '-'}
                      </span>
                    </div>
                  </div>
                </Alert>
              </div>
            </section>
          </Card.Body>
        </Card>

        <Card style={{ height: '308px' }} className="mb-3">
          <Card.Body
            style={{
              paddingTop: '12px',
              paddingRight: '16px',
              paddingBottom: '12px',
              paddingLeft: '16px',
            }}
          >
            <section>
              <span style={{ fontWeight: 'bold', fontSize: '20px' }}>
                Manfaat Pensiun Sejak Dini
              </span>

              <Alert key={'warning'} variant={'warning'}>
                <div className="d-flex flex-row align-items-center">
                  <div className="mr-3">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0C4.47301 0 0 4.4725 0 10C0 15.5269 4.4725 20 10 20C15.527 20 20 15.5275 20 10C20 4.47309 15.5275 0 10 0ZM11.0269 13.9696C11.0269 14.2855 10.5662 14.6014 10.0002 14.6014C9.40785 14.6014 8.98668 14.2855 8.98668 13.9696V8.95445C8.98668 8.5859 9.40789 8.33574 10.0002 8.33574C10.5662 8.33574 11.0269 8.5859 11.0269 8.95445V13.9696ZM10.0002 7.12484C9.39473 7.12484 8.9209 6.6773 8.9209 6.17707C8.9209 5.67687 9.39477 5.2425 10.0002 5.2425C10.5926 5.2425 11.0665 5.67687 11.0665 6.17707C11.0665 6.6773 10.5925 7.12484 10.0002 7.12484Z"
                        fill="#FFD71A"
                      />
                    </svg>
                  </div>
                  <div>{simulasiMp.peraturanOjk}</div>
                </div>
              </Alert>

              <div className="container-fluid" style={{ fontSize: '14px' }}>
                <div className="row mb-3 mt-3">
                  <div className="col-md-6">
                    <span>Saldo Unit Terakhir</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {simulasiMp.saldoUnitTerakhir
                        ? formatAsMoney(simulasiMp.saldoUnitTerakhir)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Saldo Nominal Terakhir</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {simulasiMp.saldoNominalTerakhir
                        ? formatAsMoney(simulasiMp.saldoNominalTerakhir)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Manfaat Pensiun Sekaligus 20%</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {simulasiMp.manfaatPensiun
                        ? formatAsMoney(simulasiMp.manfaatPensiun)
                        : 0}
                    </span>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <span>Pembelian Anuitas atau Produk Berkala</span>
                  </div>
                  <div className="col-md-6 d-flex justify-content-end">
                    <span style={{ fontWeight: 'bold', textAlign: 'right' }}>
                      Rp{' '}
                      {simulasiBerkala.pembelianAnuitas
                        ? formatAsMoney(simulasiBerkala.pembelianAnuitas)
                        : 0}
                    </span>
                  </div>
                </div>
              </div>
            </section>
          </Card.Body>
        </Card>
      </React.Fragment>
    )
  }
}

export default Simulasi
